import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { Ranking } from 'globals/store/events.data';
import { Attendee } from 'globals/store/attendees.data';
import { createReducer, on } from '@ngrx/store';
import { eventsActions } from './events.era';

// This file may well just be a source of models for the new performer module for now.

export interface AttendeesState extends EntityState<Attendee> {
  attendeeTypes: { [id:string]: Ranking }
}

const getDefaultAttendees = (): AttendeesState => ({
  ids: [],
  entities: {},
  attendeeTypes: {}
})

const adapter = createEntityAdapter<Attendee>()
const makeInitialState = (): AttendeesState => adapter.getInitialState(getDefaultAttendees())

export const attendeesReducer = createReducer(
  makeInitialState(),
  on(eventsActions.loadEvent, (state, action) => {
    const newState = {...adapter.upsertMany(Object.values(action.payload.attendees), state)}
    newState.attendeeTypes = !action.payload.attendeeTypes ? {} : makeMapFromListOfObjectsAndKey(action.payload.attendeeTypes, 'id')
    return newState
  }),
  on(eventsActions.unloadEvent, (state) => ({ ...makeInitialState() })),
)
export const attendeesFeature = {
  name: 'attendees',
  reducer: attendeesReducer,
  selectAttendeesState: (state) => state.attendees as AttendeesState,
  selectAttendeeTypes: (state) => state.attendees.attendeeTypes
}

export const attendeesStateSelector = (state) => state.attendees as AttendeesState